import { fetchAndDeserializeLegacyTransaction } from "@bridgesplit/utils";

import { AbfTransactionHeaders, PayFeeInputs, PAY_FEE_ENDPOINT } from "../types";
import { createAbfInstance } from "./auth";

export async function getPayFeeTransaction(authentication: AbfTransactionHeaders, arg: PayFeeInputs) {
    return [await fetchAndDeserializeLegacyTransaction(createAbfInstance(authentication), PAY_FEE_ENDPOINT, arg)];
}
